export default __webpack_public_path__ + "static/media/watch-video.f0f04c40.svg";